import script from "./charge_record.vue?vue&type=script&setup=true&lang=js"
export * from "./charge_record.vue?vue&type=script&setup=true&lang=js"

import "./charge_record.vue?vue&type=style&index=0&id=2224e4ec&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2224e4ec"]])

export default __exports__